import { MyProgramsService } from '../../../obsolete/components/my-programs/my-programs.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { HistoryService } from './history.service';
import { DashboardService } from '../my-dashboard/my-dashboard.service';
import { SharedService } from '../../../../shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
import { MyLibraryService } from '../my-library/my-library.service';

@Component({
	selector: 'app-history',
	templateUrl: './history.component.html',
	styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {
	showAllHistory: any = true;
	showCompletedHistory: any = true;

	showInProgress: any = true;
	config: SwiperOptions = {
		slidesPerView: 5,
		spaceBetween: 50,
		navigation: true,
		pagination: { clickable: true },
		scrollbar: { draggable: true },
	};
	headerTitle: any = ' ';
	showPageRoute: any = true
	showBackButtonBlack: any = true
	completionsDetails: any;
	completedCourses: any;
	userProgress: any;
	hasProgress: boolean = false;
	programs: any = [];
	blockLoader: string = "blockLoader";
	categories: any;
	filteredCategories: any;
	programByFilter: any;
	filteredCategoriesForProgress: any;
	@ViewChild('swiper', { static: false }) swiper?: SwiperComponent;

	constructor(
		private sharedService: SharedService,
		private dashboardService: DashboardService,
		private spinner: NgxSpinnerService,
		private myLibraryService: MyLibraryService,
	) {
		this.sharedService.activePrograms$.subscribe(activePrograms => {
			this.programs = activePrograms;
		});
	}

	async ngOnInit() {
		await this.getCategories();
	}

	getUser() {
		return localStorage.getItem('username');
	}

	getGroupId() {
		return localStorage.getItem('groupId');
	}

	getOrgId() {
		return localStorage.getItem('orgId');
	}

	getLearningHrs(learningDuration: any) {
		return this.sharedService.secondsToHours(learningDuration);
	}

	getTotalNumberOfSections(sections: any) {
		return this.sharedService.getTotalNumberOfSections(sections);
	}

	getTimeToComplete(startedAt: any, completedAt: any) {
		let daysTakenToComplete = moment(completedAt).diff(moment(startedAt), 'days');
		const yearsTakenToComplete = moment(completedAt).diff(moment(startedAt), 'year');
		const monthsTakenToComplete = moment(completedAt).diff(moment(startedAt), 'months');

		if (yearsTakenToComplete === 0 && monthsTakenToComplete === 0 && daysTakenToComplete === 0) {
			daysTakenToComplete = 1;
		}

		return `${(yearsTakenToComplete >= 1) ? yearsTakenToComplete + ' Yrs' : ''} ${(monthsTakenToComplete >= 1) ? monthsTakenToComplete + ' Mon' : ''} ${(daysTakenToComplete >= 1) ? daysTakenToComplete + ((daysTakenToComplete === 1) ? ' Day' : ' Days') : ''}`;
	}

	async getCategories() {
		this.categories = this.myLibraryService.getCategories().subscribe(data => {
			this.categories = data;

			if (this.categories?.length) {
				// console.log('trueee')
				this.filteredCategories = this.categories.filter((category: any) =>
					this.programs.some((program: any) => program.category.id === category.id)
				);
				this.filteredCategoriesForProgress = this.categories.filter((category: any) =>
					this.programs.some((program: any) => {
						return program.category.id === category.id && program.progress !== 100
					})
				);
			}
			// console.log('categories', this.categories);
		});
	}

	getFilteredCategories(): any {
		this.filteredCategories = this.categories.filter((category: any) =>
			this.programs.some((program: any) => program.category.id === category.id)
		);
	}

	getProgramsByCategory(categoryId: number): any[] {
		if (!this.programs) {
			return [];
		}
		return this.programs.filter((program: any) => program.category.id === categoryId);
	}
}